/*
 * Delivery Estimates -- storefront hydration.
 *
 * Reads ONE Supabase row (app_settings, key=delivery_estimate_config) -- the
 * same row the React admin (/admin/delivery-estimates) writes -- and fills in
 * the "Get it as soon as <date>" line on the product page.
 *
 * The region bucket (gb/us/ca/au/eu) is resolved server-side in Liquid from
 * localization.country.iso_code (same curated 5-market model as
 * aj-region-selector.liquid) and passed in via data-delivery-region, so this
 * script only has to pick the matching entry out of the fetched config and
 * turn "min_days" into an actual date.
 *
 * Renders hidden in Liquid; this script reveals + fills it, so there's no
 * flash of a wrong/generic estimate. Fails silent (matches campaigns.js).
 */
(function () {
  var SUPA_URL = 'https://oquugatwdfrfnnxjbldg.supabase.co';
  var SUPA_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9xdXVnYXR3ZGZyZm5ueGpibGRnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ4OTgzODksImV4cCI6MjA5MDQ3NDM4OX0.7ixhYEo1eztKqV1oX2MAnHQFuuGPrC6dZKT_krsunTY';

  // ALL matching elements, not the first: the cart page and the cart drawer
  // (present on every page) carry the same row as the product page, and a
  // single-element lookup would fill whichever happens to come first in the
  // DOM and leave the rest hidden.
  var els = Array.prototype.slice.call(document.querySelectorAll('[data-delivery-estimate]'));
  if (!els.length) return;

  function formatDate(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  // Saturday or Sunday (local time). Public holidays are NOT modelled -- the
  // post-purchase timeline (src/lib/print/dispatchEstimate.ts) deliberately does
  // not model them either, so a wrong holiday table can't make the two disagree.
  function isWeekend(d) {
    var day = d.getDay(); // 0 = Sun, 6 = Sat
    return day === 0 || day === 6;
  }

  // Advance `from` by `n` WORKING days, skipping weekends, and never land on a
  // weekend. Same rule as addWorkingDays() in dispatchEstimate.ts, so the
  // pre-purchase "as soon as" date and the post-purchase order timeline count
  // days the same way. Local time (not UTC): the whole storefront estimate, and
  // the midnight countdown below, run in the shopper's own zone.
  function addWorkingDays(from, n) {
    var d = new Date(from.getTime());
    var remaining = n;
    while (remaining > 0) {
      d.setDate(d.getDate() + 1);
      if (!isWeekend(d)) remaining--;
    }
    // A zero-day estimate still can't land on a weekend.
    while (isWeekend(d)) d.setDate(d.getDate() + 1);
    return d;
  }

  fetch(SUPA_URL + '/rest/v1/app_settings?key=eq.delivery_estimate_config&select=value', {
    headers: { apikey: SUPA_KEY, Authorization: 'Bearer ' + SUPA_KEY }
  })
    .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
    .then(function (rows) {
      var cfg = Array.isArray(rows) && rows[0] ? rows[0].value : null;
      if (!cfg || typeof cfg !== 'object' || cfg.enabled === false) return;

      els.forEach(function (el) {
        var region = el.dataset.deliveryRegion;
        var estimate = (cfg.regions && cfg.regions[region]) || cfg.default;
        var minDays = estimate && Number(estimate.min_days);
        if (!minDays && minDays !== 0) return;

        var target = addWorkingDays(new Date(), minDays);
        var dateEl = el.querySelector('[data-delivery-estimate-date]');
        if (dateEl) dateEl.textContent = formatDate(target);

        el.classList.remove('hidden');
        el.classList.add('flex');
      });

      // Honest urgency: count down to LOCAL midnight, the moment the
      // min_days-based estimate above genuinely rolls to the next day.
      // Only runs when the estimate itself rendered, so the countdown can
      // never promise a date the page is not showing.
      //
      // Now that the estimate skips weekends, that roll only happens when
      // TOMORROW is a working day. On a Friday or over the weekend the "as soon
      // as" date is unchanged until Monday, so a "changes at midnight" countdown
      // would be a false claim -- hide it then. (The condition is calendar-only,
      // so it holds for every region's min_days at once.)
      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      var rollsAtMidnight = !isWeekend(tomorrow);

      var cd = document.querySelector('[data-delivery-countdown]');
      var cdTime = cd && cd.querySelector('[data-delivery-countdown-time]');
      if (cd && cdTime && rollsAtMidnight) {
        var tick = function () {
          var now = new Date();
          var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
          var mins = Math.max(1, Math.round((midnight - now) / 60000));
          var h = Math.floor(mins / 60);
          var m = mins % 60;
          cdTime.textContent = h > 0 ? h + 'h ' + m + 'm' : m + 'm';
        };
        tick();
        setInterval(tick, 30000);
        cd.classList.remove('hidden');
        cd.classList.add('flex');
      }
    })
    .catch(function (e) { console.warn('[aj-delivery-estimate]', e); });
})();
